import React from "react"
import {FieldGlistViewProps} from "../../render/glist/glist-view";
import FieldProto_GListView from "./glist/glist-view";

export default function FieldProto_CSVImportPreview(props:FieldGlistViewProps) {

    // now default = viewSmall

    return <FieldProto_GListView {...props} />

}
